import { render, staticRenderFns } from "./RegEventListItem.vue?vue&type=template&id=3bba832a&scoped=true&"
import script from "./RegEventListItem.vue?vue&type=script&lang=js&"
export * from "./RegEventListItem.vue?vue&type=script&lang=js&"
import style0 from "./RegEventListItem.vue?vue&type=style&index=0&id=3bba832a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba832a",
  null
  
)

export default component.exports